"use client";

import React from "react";
import { CalendarCheck, ArrowRight, CircleCheck, Clock, Phone, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TurnMoreDentalLeadsIntoBookedAppointmentsAutomatically() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223387" id="the-exit-strategy-hero" className="bg-background text-foreground relative overflow-hidden py-16 lg:py-28">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/leaving_il_grid_texture.png)] bg-repeat" />
      
      {}
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-[800px] h-[800px] bg-primary/10 rounded-lg blur-3xl pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          
          {}
          <div ref={leftRef} className={`flex flex-col gap-6 max-w-2xl transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-primary/10 text-primary text-sm font-medium w-fit border border-primary/20">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75"></span>
                <span className="relative inline-flex rounded-lg h-2 w-2 bg-primary"></span>
              </span>
              Phase 1 Exit Readiness Assessment
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-serif tracking-tight text-foreground leading-[1.1] pr-2">
              Leaving Illinois? Start With a{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-chart-4 inline-block">
                Strategic Plan
              </span>
            </h1>

            <p className="text-lg md:text-xl text-muted-foreground font-default leading-relaxed">
              I'm Ed Dring, an Illinois realtor based just outside Chicago with Superior Homes Realty. Free, no-pressure planning for your move out of Illinois.
            </p>

            <div className="flex flex-col gap-4 pt-4">
              <div className="flex flex-col sm:flex-row gap-4">
                <Button asChild size="lg" className="h-14 px-8 text-base font-bold shadow-lg shadow-red-600/20 bg-red-600 text-white hover:bg-blue-700 rounded-lg">
                  <Link to="#">
                    Start Your Exit Plan
                    <ArrowRight className="ml-2 size-5" />
                  </Link>
                </Button>
              </div>
              <div className="w-fit">
                <Button asChild size="lg" className="h-14 px-8 text-base font-bold shadow-lg shadow-red-600/20 bg-red-600 text-white hover:bg-blue-700 rounded-lg">
                  <Link href="tel:+12248006979">
                    <Phone className="mr-2 size-5" />
                    Call or Text Ed: 224-800-6979
                  </Link>
                </Button>
              </div>
            </div>

            <div className="flex items-center gap-6 pt-6 text-sm text-muted-foreground font-default">
              <div className="flex items-center gap-2">
                <CircleCheck className="size-4 text-primary" />
                <span>No Hard Sell</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="size-4 text-primary" />
                <span>Personalized Roadmap</span>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`relative w-full max-w-lg mx-auto lg:ml-auto transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            {}
            <div className="absolute inset-0 -m-6 lg:-m-12 rounded-3xl overflow-hidden bg-muted">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/leaving_il_portal_gradient.png" alt="Leaving Illinois Portal" className="w-full h-full object-cover blur-sm opacity-30 scale-105" />
              <div className="absolute inset-0 bg-gradient-to-tr from-background/90 via-background/40 to-transparent" />
            </div>

            {}
            <div className="relative z-10 bg-card rounded-md shadow-2xl border-[6px] border-border/50 overflow-hidden flex flex-col h-[560px] w-full max-w-[320px] mx-auto transform rotate-[-2deg] hover:rotate-0 transition-transform duration-500">
              
              {}
              <div className="bg-chart-3 px-4 py-5 flex items-center gap-3 text-white shadow-sm z-10">
                <div className="size-10 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/leaving_il_logo_icon.png" alt="LeavingIL Logo" className="size-6 object-contain" />
                </div>
                <div>
                  <h3 className="font-serif font-semibold text-sm">Exit Strategist</h3>
                  <p className="text-xs text-white/80 flex items-center gap-1">
                    <span className="size-1.5 rounded-lg bg-primary"></span> Available Now
                  </p>
                </div>
              </div>

              {}
              <div className="flex-1 bg-muted/30 p-4 flex flex-col gap-4 overflow-hidden relative">
                <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662596/img/relocation_pattern_bg.png)] opacity-5 pointer-events-none" />
                
                {}
                <div className="flex flex-col gap-1 w-[85%] relative z-10">
                  <span className="text-[10px] text-muted-foreground ml-2 mb-1">Today, 10:15 AM</span>
                  <div className="bg-card border border-border p-3 rounded-2xl rounded-tl-none text-sm text-foreground shadow-sm font-default">
                    I'm tired of the property taxes in Cook County. How do I start my exit?
                  </div>
                </div>

                <div className="flex flex-col gap-1 w-[85%] self-end relative z-10">
                  <span className="text-[10px] text-muted-foreground mr-2 mb-1 text-right">10:16 AM</span>
                  <div className="bg-accent text-accent-foreground p-3 rounded-2xl rounded-tr-none text-sm shadow-sm font-default">
                    We hear that often. Let's start with your Phase 1 assessment to see which states fit your goals best.
                  </div>
                </div>

                <div className="flex flex-col gap-1 w-[85%] relative z-10">
                  <span className="text-[10px] text-muted-foreground ml-2 mb-1">10:18 AM</span>
                  <div className="bg-card border border-border p-3 rounded-2xl rounded-tl-none text-sm text-foreground shadow-sm font-default">
                    That sounds perfect. I'm looking at Tennessee or Florida.
                  </div>
                </div>

                {}
                <div className="flex flex-col gap-1 w-[90%] self-end mt-2 relative z-10 animate-pulse">
                  <div className="bg-primary text-primary-foreground p-4 rounded-2xl rounded-tr-none text-sm shadow-md border border-primary/20">
                    <div className="flex items-center gap-2 font-bold mb-2 font-serif">
                      <CalendarCheck className="size-4" />
                      Strategy Session Set
                    </div>
                    <p className="opacity-90 mb-2 font-default">Your relocation consultation is confirmed.</p>
                    <div className="bg-primary-foreground/10 rounded-lg p-2 text-xs flex items-center gap-2 font-default">
                      <Clock className="size-3" />
                      Tomorrow, 2:00 PM CST
                    </div>
                  </div>
                </div>
              </div>

              {}
              <div className="bg-card p-3 border-t border-border flex items-center gap-2">
                <div className="flex-1 bg-muted rounded-lg h-10 px-4 flex items-center text-sm text-muted-foreground font-default">
                  Ask about your exit...
                </div>
                <div className="size-10 rounded-lg bg-primary flex items-center justify-center text-primary-foreground shrink-0">
                  <MessageCircle className="size-5" />
                </div>
              </div>
            </div>

            {}
            <div className="absolute -right-6 top-1/4 bg-card p-3 rounded-md shadow-xl border border-border flex items-center gap-3 animate-bounce z-20 hidden md:flex">
              <div className="size-8 rounded-lg bg-primary/20 flex items-center justify-center text-primary">
                <CircleCheck className="size-5" />
              </div>
              <div>
                <p className="text-xs text-muted-foreground font-medium font-default">New Strategy</p>
                <p className="text-sm font-bold font-serif text-foreground">Plan Created</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}